// extracted by mini-css-extract-plugin
module.exports = {"container":"latest-blog-articles_container__M7YLM","title":"latest-blog-articles_title__m9pKC","article":"latest-blog-articles_article__1tNMb"};